import styled from 'styled-components';

export const StyledSection = styled.section`
  padding: 5rem 2rem;
  background-color: #F4F6FA;
  text-align: center;

  > h1 {
    margin-bottom: 4.5rem;
  }

  @media all and (max-width: 550px) {
    padding: 5rem 1rem;
  }
`;

export const ItemsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;
